import { useState, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import type { SetupProposal } from '../../functions/src/agentAdvisor/types';

interface GenerateSetupProposalRequest {
  workspaceId: string;
  language: string;
  publishEnabled: boolean;
  publishedPages: number;
  standbyPages: number;
  publicUrl: string | null;
}

interface UseSetupProposalResult {
  proposal: SetupProposal | null;
  loading: boolean;
  error: string | null;
  generate: (params: GenerateSetupProposalRequest) => Promise<void>;
}

export function useSetupProposal(): UseSetupProposalResult {
  const [proposal, setProposal] = useState<SetupProposal | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async (params: GenerateSetupProposalRequest) => {
    setLoading(true);
    setError(null);
    try {
      const fn = httpsCallable<GenerateSetupProposalRequest, { proposal: SetupProposal }>(
        functions,
        'generateSetupProposalFn'
      );
      const res = await fn(params);
      setProposal(res.data.proposal);
    } catch (err: any) {
      console.error('[useSetupProposal] generate error', err);
      setError(err?.message ?? 'Failed to generate setup proposal');
    } finally {
      setLoading(false);
    }
  }, []);

  return { proposal, loading, error, generate };
}
